import type { ColDef } from '@ag-grid-community/core';
import type { FunctionDef } from '@thinkalpha/language-services';
import type { FieldDescriptor } from '@thinkalpha/table-client';
import { CategoryForFieldType } from '@thinkalpha/ui-core/util/fields';
import { v4 as uuidv4 } from 'uuid';

export function fieldDescriptorToFunctionDef(desc: FieldDescriptor): FunctionDef {
    return {
        id: uuidv4(),
        symbol: desc.name,
        overloads: [
            {
                returnType: CategoryForFieldType.get(desc.type)!,
                params: [],
            },
        ],
    };
}

export function colDefToFunctionDef(colDef: Required<Pick<ColDef, 'tooltipComponentParams' | 'colId'>>): FunctionDef {
    return {
        id: uuidv4(),
        symbol: colDef.colId,
        overloads: [
            {
                returnType: colDef.tooltipComponentParams.dataType,
                params: [],
            },
        ],
    };
}
